import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { films } from '@/mocks/films';

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((category, index) => {
        const count = films.filter((film) => film.category === category.id).length;
        return (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group flex cursor-pointer flex-col rounded-lg border border-background-300/70 bg-background-100 p-4 transition-colors hover:border-primary-500/50 hover:bg-background-200/70 animate-rise"
            style={{ animationDelay: `${index * 40}ms` }}
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-primary-400 transition-colors group-hover:bg-primary-500/15 group-hover:text-primary-500">
              <i className={`${category.icon} text-lg`} />
            </span>
            <span className="mt-3 text-[14px] font-medium text-foreground-900">{category.name}</span>
            <span className="mt-1 text-[11px] text-foreground-500">{count} 部条目</span>
            <span className="mt-3 flex items-center gap-1 text-[11px] text-foreground-500 transition-colors group-hover:text-primary-400">
              进入分类
              <i className="ri-arrow-right-up-line" />
            </span>
          </Link>
        );
      })}
    </div>
  );
}